export default function () {
  if (document.querySelector('.edit-offer-title') !== null) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "edit-offer" */ './edit-offer/main');
  }
}
